import { useShallow } from "zustand/react/shallow";

import { api } from "@api";
import { useNotifyPromise } from "@hooks";
import {
  IAuthStepEnum,
  useAuthStore,
} from "@templates/authManagement/authStore";
import { ForgetPasswordForm } from "@templates/authManagement/forgetPasswordForm";
import { encodePhone } from "@utils";

export function ForgetPasswordView() {
  const notifyMutate = useNotifyPromise();
  const { mutateAsync: mutate, isPending } = api.auth.passwordReset.usePost();

  const setStep = useAuthStore(useShallow((state) => state.setStep));
  const setMeteData = useAuthStore(
    useShallow((state) => state.setForgetPasswordMeteData),
  );

  return (
    <ForgetPasswordForm
      isLoading={isPending}
      onSubmit={(values) => {
        notifyMutate(
          mutate(
            {
              pathParam: undefined,
              phone_number: encodePhone(values.phone),
            },
            {
              onSuccess: (data) => {
                setStep(IAuthStepEnum.CHECK_RESET_PASSWORD_VERIFICATION);
                setMeteData({
                  userName: encodePhone(values.phone),
                  reqId: data?.data?.id?.toString(),
                });
              },
            },
          ),
        ).catch(() => {});
      }}
    />
  );
}
